import { GET_ALL_CMS, GET_CMS_DETAILS } from "./actions";

const initialState = {
  cmsList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  getCmsData: {},
  loading: true,
};

const cmsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_CMS:
      return {
        ...state,
        loading: false,
        cmsList: payload,
      };
    case GET_CMS_DETAILS:
      return {
        ...state,
        getCmsData: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default cmsReducer;
